import Data from './data'

export default {
    list: () => [200, Data.list],
    get: () => {
        const { data } = Data.list
        return [200, { data: [data[0]] }]
    },
}
